import React from 'react';

import { useSelector } from 'react-redux';
import { selectAdvisories } from '../../store/alternate-data/alternate-data.selector';
import { selectYear } from '../../store/episodes/episodes.selector';
import { selectAttributeInfo } from '../../store/options/options.selector';
import { selectCurrentLocation } from '../../store/map/map.selector';

import HurricaneItem from '../hurricane-item/hurricane-item.component';

export default function HurricaneItems() {
  const year = useSelector(selectYear);
  const attrInfo = useSelector(selectAttributeInfo);
  const hurricaneData = useSelector(selectAdvisories);
  const currentLocation = useSelector(selectCurrentLocation);

  return (
    <>
      {hurricaneData.length ? (
        hurricaneData.map((storm, i) => <HurricaneItem key={i} storm={storm} selectedLocation={currentLocation} />)
      ) : (
        <div className='episodes-timeline-none'>
          There were no {attrInfo.name} for <b>{year}</b> in this location.
        </div>
      )}
    </>
  );
}
